import { all, fork } from 'redux-saga/effects';
import watchContractSagas from "./contractSaga";
import watchEmployeeSagas from "./employeeSaga";
import watchEmploymentSagas from "./employmentSaga";
import watchJobProfileSagas from "./jobProfileSaga";
import watchJointPowersSagas from "./jointPowersSaga";
import watchAuthenticationSagas from "./authenticationSaga";
import watchOrganizationSaga from "./organizationSaga";

export default function* rootSaga() {
    yield all([
        fork(watchAuthenticationSagas),
        fork(watchContractSagas),
        fork(watchEmployeeSagas),
        fork(watchEmploymentSagas),
        fork(watchJobProfileSagas),
        fork(watchJointPowersSagas),
        fork(watchOrganizationSaga)
    ]);
}
